import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core"
import * as moment from "moment"
import { Modalable } from "@app/Modalable"
import { COMMON_IMPORTS } from "@app/common-imports"
import { GenSelectComponent } from "@app/gen-inputs/gen-select/gen-select.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { GenButtonGroupComponent } from "@app/gen-inputs/gen-button-group/gen-button-group.component"
import { SpinOrContent } from "@app/utils/utils.component"
import { KeyValuePipe } from "@angular/common"
import { NgxChartsModule } from "@swimlane/ngx-charts"

@Component({
	selector: "app-graphs-data",
	imports: [
		COMMON_IMPORTS,
		GenSelectComponent,
		LangValPipe,
		GenButtonGroupComponent,
		SpinOrContent,
		KeyValuePipe,
		NgxChartsModule,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "./graphs-data.component.html",
})
export class GraphsDataComponent extends Modalable {
	// cached:any={};
	data: any = {}
	freq: string = "monthly"
	isLoading: boolean = false
	timeRange: string = "this_year"
	yearFrom: number = 0
	yearTo: number = 0
	curData: any = null
	years: any[] = [] //the options for years to choose from

	fields: any = null

	vat_numbers: any[] = []
	is_new_vat_number: boolean = false
	vat_number: string = ""

	outputGraphs: any[] = [
		{ name: "income", lang: "income_price" },
		{ name: "hours", lang: "hours" },
		{ name: "patients", lang: "patients" },
	]

	ngOnInit() {
		const thisYear = (moment as any)().year()
		for (let i = 2020; i <= thisYear; i++) {
			this.years.push({ id: i, name: i })
		}

		this.fields = {
			income: {
				price_total: true,
				invoices: true,
			},
			hours: {
				meetings: true,
			},
			patients: {
				new_patients: true,
				inquirers: true,
				patients_with_meeting: true,
				existing: true,
			},
		}

		if (!this.permsService.perms?.administrative) {
			this.outputGraphs = this.outputGraphs.filter((it) => it.name != "income")
		}

		this.vat_number = ""
		const cliniqData = this.store.cc()

		if (cliniqData.is_new_vat_number == "yes") {
			this.is_new_vat_number = true
			this.vat_numbers = [
				{ id: "", name: this.lang.getVal("all_vat_numbers") },
				{ id: cliniqData.old_vat_number, name: cliniqData.old_vat_number },
				{ id: cliniqData.vat_number, name: cliniqData.vat_number },
			]
		}
		this.freqChange()
		this.getData()
	}

	freqChange() {
		if (this.freq == "yearly") {
			this.yearTo = (moment as any)().year()
			this.yearFrom = this.yearTo - 2
		} else {
			this.timeRange = "this_year"
		}
	}

	async getData() {
		// if(this.cached[this.freq]){
		//   return this.renderData();
		// }

		this.isLoading = true
		const res: any = await this.apiService.post(
			"get_graphs_data",
			this,
			"freq,timeRange,yearFrom,yearTo,vat_number"
		)
		// this.cached[this.freq]=res.data;
		this.curData = res.data
		this.renderData()
		this.isLoading = false
	}
	renderData() {
		const baseData: any = this.curData

		this.data = {}

		let times: any[] = []
		let timeCur

		timeCur = (moment as any)().startOf("year")
		if (this.timeRange == "last_year") {
			timeCur.subtract(1, "year")
		}

		switch (this.freq) {
			case "monthly":
				for (let i = 0; i < 12; i++) {
					times.push(timeCur.format("MM-YYYY"))
					timeCur.add(1, "month")
				}
				break
			case "quarterly":
				for (let i = 0; i < 4; i++) {
					times.push(timeCur.format("YYYY-[Q]Q"))
					timeCur.add(3, "month")
				}
				break
			case "yearly":
				for (let i = this.yearFrom; i <= this.yearTo; i++) {
					times.push(String(i))
				}
				// timeCur=(moment as any)().subtract(2,"year");
				// for(let i=0;i<3;i++){
				//   timeCur.add(1,"year");
				// }
				break
		}

		Object.keys(this.fields).forEach((graphName) => {
			const fieldNames = Object.keys(this.fields[graphName]).filter(
				(f) => this.fields[graphName][f]
			)
			this.data[graphName] = times.map((timeStr) => {
				const series = fieldNames.map((fieldName) => {
					const found = baseData[graphName][fieldName]?.find(
						(it) => it.date_form == timeStr
					)
					return {
						name: this.lang.getVal(fieldName),
						ogName: fieldName,
						value: found?.val || 0,
					}
				})
				return {
					name: timeStr,
					series,
				}
			})
		})

		if (this.fields.patients.existing) {
			let curVal = baseData.patients.existingPreFirst
			this.data.patients.forEach((timeInst) => {
				const existingInst = timeInst?.series.find(
					(it) => it.ogName == "existing"
				)
				if (existingInst) {
					curVal += existingInst.value
					existingInst.value = curVal
				}
			})
		}
	}

	//graph info:
	colorScheme: any = {
		domain: ["#5AA454", "#A10A28", "#C7B42C", "#AAAAAA"],
	}
	// view: any = [380, 600]

	onSelect(data) {}

	onActivate(data) {}

	onDeactivate(data) {}
}
